/* eslint-disable no-shadow */
/* eslint-disable no-param-reassign */
/* eslint-disable no-underscore-dangle */
import React from 'react';
import { Formik } from 'formik';
import { ADD_EDIT_CONSTANT } from 'utils/constants';
import ErrorBoundary from 'components/common/ErrorBoundary';
import { APP_UI } from 'pages/ApplicationUI/constant';
import { NEWSValidationSchema } from 'pages/ApplicationUI/components/FAQ/constants';
import AddEditNewsForm from './components/AddEditNewsForm';

const AddEditNews = ({
  toggleFAQForm,
  type,
  value,
  saveUISetting,
  refetch = () => {},
}) => {
  const handleSubmit = async (values) => {
    if (values?.__typename) delete values.__typename;
    if (values?.createdAt) delete values.createdAt;
    if (values?.updatedAt) delete values.updatedAt;

    await saveUISetting({
      variables: {
        appUISetting: {
          ...values,
          isActive: true,
          settingName: APP_UI.NEWS,
        },
      },
    });
    refetch();
    toggleFAQForm();
  };

  return (
    <div>
      <ErrorBoundary>
        <Formik
          initialValues={
            type === ADD_EDIT_CONSTANT.EDIT
              ? {
                  ...value,
                }
              : {
                  settingValue: '',
                }
          }
          enableReinitialize
          validationSchema={NEWSValidationSchema}
          onSubmit={handleSubmit}
          children={(props) => {
            return (
              <AddEditNewsForm
                {...props}
                type={type}
                toggleFAQForm={toggleFAQForm}
              />
            );
          }}
        />
      </ErrorBoundary>
    </div>
  );
};

export default AddEditNews;
